var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:([_vm.currentStyle]),on:{"mouseover":_vm.mouseEnter,"click":_vm.click,"mouseleave":_vm.mouseLeave}},[_c('div',{staticClass:"dot__item",class:_vm.clZObj})])}
var staticRenderFns = []

export { render, staticRenderFns }